module.exports = __webpack_public_path__ + "static/img/activity11.f8aaa43d.png";